module.exports = __webpack_public_path__ + "img/function_img3_fan.a55195c5.png";